class EmailService {
  private emailChangedHandlers: ((id: number) => Promise<void> | void)[] = [];

  /**
   * Register a handler to be called when an email changes
   * @param handler Function to call when an email changes
   * @returns A function that can be called to unsubscribe the handler
   */
  onEmailChanged(handler: (id: number) => Promise<void> | void): () => void {
    this.emailChangedHandlers.push(handler);
    
    // Return unsubscribe function
    return () => {
      const index = this.emailChangedHandlers.indexOf(handler);
      if (index !== -1) {
        this.emailChangedHandlers.splice(index, 1);
      }
    };
  }

  /**
   * Notify all subscribers that an email has changed
   * @param id The ID of the changed email
   */
  async emailChanged(id: number): Promise<void> {
    const promises = this.emailChangedHandlers.map(handler => handler(id));
    await Promise.all(promises);
  }
}

const emailService = new EmailService();
export default emailService;
